import { render, staticRenderFns } from "./MoleculeContentBlockEmbed.vue?vue&type=template&id=46c3b717&"
import script from "./MoleculeContentBlockEmbed.vue?vue&type=script&lang=js&"
export * from "./MoleculeContentBlockEmbed.vue?vue&type=script&lang=js&"
import style0 from "./MoleculeContentBlockEmbed.vue?vue&type=style&index=0&id=46c3b717&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports